// 请不要随意修改，否则可能造成程序出错，修改代码请参照 USAGE.md 文件！！！

import crypt from '@/util/components/crypt'

const __ = 'hIJgyNdTbdOkhgFB1638654332564309'

export const getLocal = (key, parse = false) => {
    let defaultValue = parse ? '{}' : ''
    let _value = localStorage.getItem(key)
    try {
        _value = crypt.decrypt(__, _value)
    } catch (err) {
        _value = ''
    }
    let value = _value || defaultValue
    return parse ? JSON.parse(value) : value
}

export const setLocal = (key, value) => {
    let _value = value
    if (typeof (_value) !== 'string') {
        _value = JSON.stringify(_value)
    }
    _value = crypt.encrypt(__, _value)
    localStorage.setItem(key, _value)
}

export const removeLocal = (key) => {
    localStorage.removeItem(key)
}

export const removeAll = () => {
    localStorage.clear()
}
